import React from 'react';
import './Services4.css';
import { FaComments, FaUserTie, FaCheckCircle, FaRobot, FaHeadset, FaBrain, FaCog, FaNetworkWired, FaShieldAlt, FaChartLine, FaUsers, FaBell, FaShip } from 'react-icons/fa';
import Footer from '../../Footer/Footer';
import Navbar1 from '../../Navbar/Navbar1/Navbar1';


const includedModules = [
  {
    title: 'QMS Assistant',
    desc: 'Access policies, ISM manuals, checklists, audits, NCRs',
    target: 'Safety Officer',
    tags: ['QHSE', 'ISM'],
  },
  {
    title: 'Chartering Assistant',
    desc: 'View charter parties, voyage orders, CP terms, market data',
    target: 'Chartering Manager',
    tags: ['Voyage Planning', 'Commercial'],
  },
  {
    title: 'Maintenance Assistant',
    desc: 'Access PMS logs, defect history, and spare parts details',
    target: 'Chief Engineer',
    tags: ['Maintenance'],
  },
  {
    title: 'Procurement Assistant',
    desc: 'Track POs, RFQs, invoices, vendor files',
    target: 'Purchase Officer',
    tags: ['Purchasing', 'Supply Chain'],
  },
  {
    title: 'Crewing Assistant',
    desc: 'Monitor certificates, visa expiry, travel, appraisals',
    target: 'Crewing Manager',
    tags: ['HR', 'Crewing'],
  },
  {
    title: 'Compliance & Vetting Assistant',
    desc: 'Handle SIRE, PSC, CDI, RightShip reports, and observation tracking',
    target: 'Vetting Officer',
    tags: ['Vetting', 'QHSE'],
  },
  {
    title: 'Finance & Accounts Assistant',
    desc: 'Drive P&L/CAPEX reports, invoices, budget planning',
    target: 'Finance Manager',
    tags: ['Accounts', 'Budgeting'],
  },
  {
    title: 'Operations Assistant',
    desc: 'Port rotation, cargo ops, voyage summaries, sail plans',
    target: 'Cargo Planner',
    tags: ['Ops', 'Execution'],
  },
  {
    title: 'Safety & Environmental Assistant',
    desc: 'E-logs, MRV/IMO-DCS reporting, forms, SEEMP',
    target: 'Technical Manager',
    tags: ['Environment', 'Safety'],
  },
  {
    title: 'IT & Cybersecurity Assistant',
    desc: 'Track IT inventory, software licenses, support history',
    target: 'IT Admin',
    tags: ['IT', 'Security'],
  },
  {
    title: 'Projects & Dry Docking Assistant',
    desc: 'Project logs, docking specs, yard quotes, project notes',
    target: 'Project Manager',
    tags: ['Docking', 'Planning'],
  },
];


const Services4 = ({ onNavigate }) => {
    const securityFeatures = [
      {
        title: 'Role-Based Access Control',
        desc: 'Users only see information relevant to their role',
      },
      {
        title: 'Linked Document Support',
        desc: 'Answers are backed by real documents or data entries',
      },
      {
        title: 'Audit Trail',
        desc: 'All usage can be monitored for transparency and compliance',
      },
      {
        title: 'Secure Deployment Options',
        desc: 'Cloud or on-premises flexibility',
      },
      {
        title: 'Built for Low Bandwidth',
        desc: 'Optimised for vessel-side connectivity',
      },
    ];
  return (
    <>
          <Navbar1 onNavigate={onNavigate} />
      <section className="chat-suite-section">
        <div className="chat-suite-container">
          <h1 className="chat-suite-title">Shipshape Chat Suite™</h1>
          <p className="chat-suite-subtext">
            A smart, secure, and lightning-fast AI platform built to streamline operations across the
            shipping industry. Designed for both shipboard teams and shore-based departments.
          </p>

          <div className="chat-suite-tags">
            <span className="chat-suite-tag">Maritime AI</span>
            <span className="chat-suite-tag">Secure & Compliant</span>
            <span className="chat-suite-tag">Lightning Fast</span>
          </div>

          <div className="chat-suite-highlight">
            <span role="img" aria-label="pointing">👉</span> You don't need to change your existing software — <strong>Shipshape works on top of your current IT systems.</strong>
          </div>
        </div>
      </section>

      {/* AI Support Section */}
      <section className="ai-support-section">
        <div className="ai-support-container">
          <h2 className="ai-support-heading">AI Support Aligned with Real Maritime Workflows</h2>
          <p className="ai-support-subtext">
            Each assistant operates in the language and context of your department, cutting
            through noise and delivering precisely what matters—no more, no less.
          </p>

          <div className="ai-support-grid">
            <div className="ai-support-card">
              <FaShieldAlt className="ai-icon" />
              <h3>Role-Based Access Control</h3>
              <p>Users only see information relevant to their role</p>
            </div>
            <div className="ai-support-card">
              <FaComments className="ai-icon" />
              <h3>Linked Document Support</h3>
              <p>Answers are backed by real documents or data entries</p>
            </div>
            <div className="ai-support-card">
              <FaChartLine className="ai-icon" />
              <h3>Audit Trail</h3>
              <p>All usage can be monitored for transparency and compliance</p>
            </div>
            <div className="ai-support-card">
              <FaCog className="ai-icon" />
              <h3>Secure Deployment Options</h3>
              <p>Cloud or on-premises flexibility</p>
            </div>
            <div className="ai-support-card">
              <FaNetworkWired className="ai-icon" />
              <h3>Built for Low Bandwidth</h3>
              <p>Optimised for vessel-side connectivity</p>
            </div>
          </div>
        </div>
      </section>

      {/* Included Modules Section */}
      <section className="included-modules-section">
        <h2 className="included-title">Included Modules</h2>
        <p className="included-subtext">11 specialized AI assistants tailored for maritime operations</p>
        <div className="module-grid">
          {includedModules.map((mod, i) => (
            <div className="module-card" key={i}>
            <h3 className="module-title">{mod.title}</h3>
            <p className="module-desc">{mod.desc}</p>
          
            <p className="target-label">Target User:</p>
            <div className="module-tags">
              {mod.tags.map((tag, i) => (
                <span key={i} className="tag-chip">{tag}</span>
              ))}
            </div>
          
            <div className="module-chat-bubble">
              <span>"What's MV Titan's next port rotation?"</span>
            </div>
          </div>
          
          ))}
        </div>
      </section>

       {/* Security Section */}
       <section className="security-section">
        <h2 className="security-title">Security, Access, and Control</h2>
        <div className="security-grid">
          {securityFeatures.map((feature, i) => (
            <div className="security-item" key={i}>
              <FaCheckCircle className="tick-icon" />
              <div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      

      <section className="why-choose-suite">
  <h2 className="why-choose-title">Why Choose Shipshape Chat Suite™?</h2>
  <div className="why-choose-grid">
    <div className="why-card">
      <FaBrain className="why-icon" />
      <h3>Focused AI for Each Function</h3>
      <p>No clutter, just clarity</p>
    </div>
    <div className="why-card">
      <FaComments className="why-icon" />
      <h3>Familiar Language</h3>
      <p>Each assistant "speaks" your department's terminology</p>
    </div>
    <div className="why-card">
      <FaShieldAlt className="why-icon" />
      <h3>Built with Privacy & Control</h3>
      <p>Security and compliance at its core</p>
    </div>
    <div className="why-card">
      <FaCog className="why-icon" />
      <h3>Works with Your Systems</h3>
      <p>Built on top of your existing documents and systems</p>
    </div>
    <div className="why-card">
      <FaNetworkWired className="why-icon" />
      <h3>Rapid Deployment</h3>
      <p>Quick to implement, easy to scale</p>
    </div>
    <div className="why-card">
      <FaShip className="why-icon" />
      <h3>Maritime Expertise</h3>
      <p>Built specifically for the shipping industry</p>
    </div>
  </div>
</section>


<section className="transform-section">
  <h2 className="transform-title">Ready to Transform Your Maritime Operations?</h2>
  <p className="transform-subtext">
    Get precise answers from your own documents and data through an intuitive, conversational interface.
  </p>
              <button className="transform-button" onClick={() => onNavigate('contact')}>Schedule Demo</button>
</section>

      <Footer onNavigate={onNavigate} />
    </>
  );
};

export default Services4;
